<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for-->
  <div
    class="page--add-product"
    :class="{
      'section-add-product-detail': /product_detail/.test(section),
      'section-success': section === 'success',
    }"
  >
    <div
      class="container-add-product"
      :class="{
        'container-add-product--add-attribute': /attribute/.test(section),
      }"
    >
      <a v-show="hideBackStep && screen.isDesktop" href="" class="text-back-section" @click.prevent="discard">
        <img src="/assets/img/icons/back-state.svg" alt="SOCO" />
        Back
      </a>
      <div v-show="hideBackStep && !screen.isDesktop" class="text-back-section">
        <a href="" @click.prevent="discard">
          <img src="/assets/img/icons/back-state-mobile.svg" alt="SOCO" style="width: 22px" />
        </a>
        <span class="text-back-section__heading">{{ textHeaderMobile }}</span>
      </div>

      <div class="content-add-product">
        <div v-if="section === 'add_product'" class="section-add-product">
          <div class="banner">
            <h4 class="banner__heading">Add Product</h4>
            <p class="banner__text">
              Produk yang kamu cari tidak ditemukan. Tapi, jangan khawatir! Kamu bisa submit product yang kamu cari ke
              SOCO
            </p>
            <img v-if="screen.isDesktop" src="/assets/img/bg-add-product.png" height="215" class="banner__img" />
            <img v-else src="/assets/img/bg-add-product-mobile.png" height="154" class="banner__img" />
          </div>

          <form
            class="form--input-uniform form--add-product"
            :style="{
              top: !screen.isDesktop && windowHeight > 470 ? '226px' : '0px',
            }"
          >
            <div class="row">
              <div class="col-md-12 col-xs-12 col-universal mb-16">
                <div v-click-outside="hideMegaMenuBrands" class="input-row">
                  <label class="form-label">Brand <span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <input
                      id="brandname"
                      v-model="form.brand.name"
                      v-validate="'required|min:3'"
                      type="text"
                      class="default"
                      name="brand name"
                      placeholder="Select Brand"
                      :readonly="isReadOnlyInputProductName"
                      autocomplete="off"
                      @focus="onFocusBrands"
                      @blur="cancelSearch()"
                    />
                    <span class="icon dropdown"></span>
                    <div v-show="isOpenMegaMenuBrands" class="dropdown-with-search">
                      <div class="dropdown-with-search__header hidden-desktop">
                        <h2 class="dropdown-with-search__header__heading">SELECT BRAND</h2>
                        <a href="" class="dropdown-with-search__header__dismiss" @click.prevent="hideMegaMenuBrands">
                          <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" />
                        </a>
                      </div>
                      <div class="input-group">
                        <div class="input-group__icon input-group__icon-search"></div>
                        <input
                          v-model="searchBrandValue"
                          type="text"
                          name="search_brand"
                          class="form-control input-group__form"
                          placeholder="Search brand.."
                          autocomplete="off"
                          @keyup="searchBrand"
                        />
                      </div>

                      <div class="dropdown-with-search__content">
                        <ul class="list-alphabets">
                          <li
                            v-for="(alphabet, key) in alphabets"
                            :key="`item-brands-letter-${key}`"
                            :class="{
                              disabled: !brands[alphabet],
                              hidden: searchBrandValue.length,
                            }"
                          >
                            <a href="" @click.prevent="scrollToSpecificBrand(`brand_${alphabet}`)">
                              {{ alphabet }}
                            </a>
                          </li>
                        </ul>

                        <div v-if="!isLoadingMegeMenuBrands" id="addProductListBrands" class="list-brands">
                          <div v-if="$SO.size(brands)">
                            <!-- eslint-disable-next-line vue/no-v-for-template-key -->
                            <template v-for="(listBrands, alphabet) in brands" v-if="listBrands.length">
                              <h4
                                :id="`brand_${alphabet}`"
                                :key="`brand_${alphabet}`"
                                class="list-brands__heading"
                                :class="{
                                  hidden: searchBrandValue.length,
                                }"
                              >
                                {{ alphabet }}
                              </h4>
                              <ul :key="alphabet" class="list-brands__name">
                                <li v-for="(brand, key) in listBrands" :key="key">
                                  <a href="" @click.prevent="addValueToInputBrand(brand)">{{ brand.name }}</a>
                                </li>
                              </ul>
                            </template>
                          </div>
                          <p v-else class="list-brands__text-empty">
                            Can’t find a certain brand name?
                            <a href="" @click.prevent="addBrand()">Add Brand</a>
                          </p>
                        </div>
                        <div v-else class="list-brands">
                          <GFMP
                            v-for="i in 6"
                            :key="i"
                            :styles="{
                              minHeight: '26px',
                              width: '100%',
                              marginBottom: '10px',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-xs-12 col-universal mb-30">
                <div class="input-row">
                  <label class="form-label">Product Name <span class="input-mandatory">*</span></label>
                  <div v-click-outside="hideProductOptions" class="input-box">
                    <input
                      id="productname"
                      v-model="form.product.name"
                      v-validate="'required|min:3'"
                      type="text"
                      class="default"
                      name="product name"
                      placeholder="Input Product Name"
                      :disabled="!form.brand.name"
                      autocomplete="off"
                      @keyup.exact="onKeyupProduct"
                      @blur="cancelSearch()"
                    />
                    <span class="icon dropdown"></span>
                    <ul v-if="options.products && options.products.length > 0" class="dropdown--selectbox">
                      <li
                        v-for="(product, i) in options.products"
                        :key="i"
                        @click.prevent="redirectProduct(product)"
                        @enter="selectProduct(product)"
                      >
                        {{ product.name }}
                      </li>
                    </ul>
                    <p v-show="errors.has('product name')" class="text-error">
                      {{ errors.first('product name') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-fix-bottom">
              <div class="col-xs-12">
                <button
                  type="button"
                  class="btn red btn-block btn-next"
                  :class="{ disabled: isNextDisabled }"
                  @click.prevent="next"
                >
                  NEXT
                </button>
              </div>
            </div>
          </form>
        </div>

        <div v-if="section === 'add_brand'" class="section-add-brand section-default">
          <h2 class="heading hidden-mobile">Add New Brand</h2>

          <p class="text-helped">Please add more detail about the brand</p>

          <form class="form--input-uniform form--add-product-detail">
            <div class="row">
              <div class="col-md-12 col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="form-label">Brand Name <span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <input
                      v-model="form.brand.name"
                      type="text"
                      class="default"
                      placeholder="Input brand name"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Brand Description</label>
                  <div class="input-box">
                    <textarea
                      v-model="form.brand.description"
                      name="product description"
                      placeholder="Write the description about the brand"
                    ></textarea>
                    <p v-show="errors.has('product description')" class="text-error">
                      {{ errors.first('product description') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div v-click-outside="hideRegionDropdown" class="input-row">
                  <label class="form-label">Region <span class="input-mandatory">*</span></label>

                  <div class="input-box">
                    <input
                      id="region"
                      v-model="form.region.name"
                      v-validate="'required'"
                      type="text"
                      class="default"
                      name="region"
                      placeholder="Region from this brand"
                      :readonly="isReadOnlyInputRegion"
                      autocomplete="off"
                      @focus="onFocusRegion"
                    />
                    <span class="icon dropdown"></span>
                    <div v-show="isOpenRegionDropdown" class="dropdown-with-search dropdown-with-search--add-brand">
                      <div class="dropdown-with-search__header hidden-desktop">
                        <h2 class="dropdown-with-search__header__heading">SELECT REGION</h2>
                        <a href="" class="dropdown-with-search__header__dismiss" @click.prevent="hideRegionDropdown">
                          <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" />
                        </a>
                      </div>

                      <div class="input-group">
                        <div class="input-group__icon input-group__icon-search"></div>
                        <input
                          v-model="searchRegionValue"
                          type="text"
                          name="search_brand"
                          class="form-control input-group__form"
                          placeholder="Search region…"
                          autocomplete="off"
                          @keyup="searchRegion"
                        />
                      </div>

                      <div class="dropdown-with-search__content">
                        <div v-if="!isLoadingRegion" class="dropdown-wrapper dropdown-wrapper-region">
                          <template v-if="$SO.size(options.region)">
                            <ul class="list-dropdown">
                              <li
                                v-for="(region, key) in options.region"
                                :key="key"
                                :class="{
                                  hidden: region.isHidden,
                                }"
                              >
                                <a href="" @click.prevent="addValueToInputRegion(region)">
                                  {{ region.name }}
                                </a>
                              </li>
                            </ul>
                          </template>
                        </div>
                        <div v-else class="dropdown-wrapper">
                          <GFMP
                            v-for="i in 6"
                            :key="i"
                            :styles="{
                              minHeight: '26px',
                              width: '100%',
                              marginBottom: '10px',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div v-click-outside="hideCountryDropdown" class="input-row">
                  <label class="form-label">Country <span class="input-mandatory">*</span></label>

                  <div class="input-box">
                    <input
                      id="country"
                      v-model="form.country.name"
                      v-validate="'required'"
                      type="text"
                      class="default"
                      name="country"
                      placeholder="Country from this brand"
                      :readonly="isReadOnlyInputCountry"
                      autocomplete="off"
                      @focus="onFocusCountry"
                    />
                    <span class="icon dropdown"></span>
                    <div v-show="isOpenCountryDropdown" class="dropdown-with-search">
                      <div class="dropdown-with-search__header hidden-desktop">
                        <h2 class="dropdown-with-search__header__heading">SELECT COUNTRY</h2>
                        <a href="" class="dropdown-with-search__header__dismiss" @click.prevent="hideCountryDropdown">
                          <img src="/assets/img/icons/close-modal.svg" alt="icon-close-modal" />
                        </a>
                      </div>

                      <div class="input-group">
                        <div class="input-group__icon input-group__icon-search"></div>
                        <input
                          v-model="searchCountryValue"
                          type="text"
                          name="search_brand"
                          class="form-control input-group__form"
                          placeholder="Search Country…"
                          autocomplete="off"
                          @keyup="searchCountry"
                        />
                      </div>

                      <div class="dropdown-with-search__content">
                        <ul class="list-alphabets list-alphabets--country">
                          <li
                            v-for="(alphabet, key) in alphabets"
                            :key="`item-country-letter-${key}`"
                            :class="{
                              disabled: !options.country[alphabet],
                              hidden: searchCountryValue.length,
                            }"
                          >
                            <a href="" @click.prevent="scrollToSpecificCountry(`country_${alphabet}`)">
                              {{ alphabet }}
                            </a>
                          </li>
                        </ul>

                        <div
                          v-if="!isLoadingCountry"
                          id="dropdownCountry"
                          class="dropdown-wrapper dropdown-wrapper-country"
                        >
                          <template v-if="$SO.size(options.country)">
                            <template v-for="(listCountry, alphabet) in options.country" v-if="listCountry.length">
                              <h4
                                :id="`country_${alphabet}`"
                                :key="alphabet"
                                class="list-brands__heading"
                                :class="{
                                  hidden: searchCountryValue.length,
                                }"
                              >
                                {{ alphabet }}
                              </h4>

                              <ul
                                :key="alphabet"
                                class="list-dropdown"
                                :class="{
                                  'list-dropdown--search-active': searchCountryValue.length,
                                }"
                              >
                                <li
                                  v-for="(country, key) in listCountry"
                                  :key="`list-country-${key}`"
                                  :class="{
                                    hidden: country.isHidden,
                                  }"
                                >
                                  <a href="" @click.prevent="addValueToInputCountry(country)">
                                    <img :src="country.flag" width="20" height="14" class="county-flag" />
                                    {{ country.name }}
                                  </a>
                                </li>
                              </ul>
                            </template>
                          </template>
                        </div>
                        <div v-else class="dropdown-wrapper">
                          <GFMP
                            v-for="i in 6"
                            :key="i"
                            :styles="{
                              minHeight: '26px',
                              width: '100%',
                              marginBottom: '10px',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Brand image</label>
                  <div class="input-box">
                    <div class="input-image" :class="{ filled: imageBrand }">
                      <img :src="imageBrand ? imageBrand : `/assets/img/add-photo-new.png`" height="100" width="100" />
                      <a href="" class="input-image__form" @click.prevent="openModalUploadImage"></a>
                      <a v-if="imageBrand" href="" class="input-image__clear" @click.prevent="clearImageBrand">
                        <img src="/assets/img/icons/clear.svg" height="18" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-fix-bottom">
              <div class="col-xs-12">
                <button
                  type="button"
                  class="btn red btn-block btn-next"
                  :class="{ disabled: isNextDisabled || isLoadingSubmitBrand }"
                  @click.prevent="next"
                >
                  ADD BRAND
                </button>
              </div>
            </div>
          </form>
        </div>

        <div v-if="section === 'edit_brand'" class="section-add-brand section-default">
          <h2 class="heading hidden-mobile">Edit Brand</h2>

          <p class="text-helped">Please add more detail about the brand</p>

          <form class="form--input-uniform form--add-product-detail">
            <div class="row">
              <div class="col-md-12 col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="form-label">Brand Name <span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <input
                      v-model="form.brand.name"
                      type="text"
                      class="default"
                      placeholder="Input brand name"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Brand Description</label>
                  <div class="input-box">
                    <textarea
                      v-model="form.brand.description"
                      name="product description"
                      placeholder="Write the description about the brand"
                    ></textarea>
                    <p v-show="errors.has('product description')" class="text-error">
                      {{ errors.first('product description') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div v-click-outside="hideRegionDropdown" class="input-row">
                  <label class="form-label">Region <span class="input-mandatory">*</span></label>

                  <div class="input-box">
                    <input
                      id="region"
                      v-model="form.region.name"
                      v-validate="'required'"
                      type="text"
                      class="default"
                      name="region"
                      placeholder="Region from this brand"
                      :readonly="isReadOnlyInputRegion"
                      autocomplete="off"
                      @focus="onFocusRegion"
                    />
                    <span class="icon dropdown"></span>
                    <div v-show="isOpenRegionDropdown" class="dropdown-with-search dropdown-with-search--add-brand">
                      <div class="input-group">
                        <div class="input-group__icon input-group__icon-search"></div>
                        <input
                          v-model="searchRegionValue"
                          type="text"
                          name="search_brand"
                          class="form-control input-group__form"
                          placeholder="Search region…"
                          autocomplete="off"
                          @keyup="searchRegion"
                        />
                      </div>

                      <div v-if="!isLoadingRegion" class="dropdown-wrapper dropdown-wrapper-region">
                        <div v-if="$SO.size(options.region)">
                          <ul class="list-dropdown">
                            <li
                              v-for="(region, key) in options.region"
                              :key="key"
                              :class="{
                                hidden: region.isHidden,
                              }"
                            >
                              <a href="" @click.prevent="addValueToInputRegion(region)">
                                {{ region.name }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div v-else class="dropdown-wrapper">
                        <GFMP
                          v-for="i in 6"
                          :key="i"
                          :styles="{
                            minHeight: '26px',
                            width: '100%',
                            marginBottom: '10px',
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div v-click-outside="hideCountryDropdown" class="input-row">
                  <label class="form-label">Country <span class="input-mandatory">*</span></label>

                  <div class="input-box">
                    <input
                      id="country"
                      v-model="form.country.name"
                      v-validate="'required'"
                      type="text"
                      class="default"
                      name="country"
                      placeholder="Country from this brand"
                      :readonly="isReadOnlyInputCountry"
                      autocomplete="off"
                      @focus="onFocusCountry"
                    />
                    <span class="icon dropdown"></span>
                    <div v-show="isOpenCountryDropdown" class="dropdown-with-search">
                      <div class="input-group">
                        <div class="input-group__icon input-group__icon-search"></div>
                        <input
                          v-model="searchCountryValue"
                          type="text"
                          name="search_brand"
                          class="form-control input-group__form"
                          placeholder="Search Country…"
                          autocomplete="off"
                          @keyup="searchCountry"
                        />
                      </div>

                      <ul class="list-alphabets list-alphabets--country">
                        <li
                          v-for="(alphabet, key) in alphabets"
                          :key="`item-country-letter-${key}`"
                          :class="{
                            disabled: !options.country[alphabet],
                            hidden: searchCountryValue.length,
                          }"
                        >
                          <a href="" @click.prevent="scrollToSpecificCountry(`country_${alphabet}`)">
                            {{ alphabet }}
                          </a>
                        </li>
                      </ul>

                      <div
                        v-if="!isLoadingCountry"
                        id="dropdownCountry"
                        class="dropdown-wrapper dropdown-wrapper-country"
                      >
                        <div v-if="$SO.size(options.country)">
                          <template v-for="(listCountry, alphabet) in options.country" v-if="listCountry.length">
                            <h4
                              :id="`country_${alphabet}`"
                              :key="`country_${alphabet}`"
                              class="list-brands__heading"
                              :class="{
                                hidden: searchCountryValue.length,
                              }"
                            >
                              {{ alphabet }}
                            </h4>

                            <ul :key="alphabet" class="list-dropdown">
                              <li
                                v-for="(country, key) in listCountry"
                                :key="`list-country-${key}`"
                                :class="{
                                  hidden: country.isHidden,
                                }"
                              >
                                <a href="" @click.prevent="addValueToInputCountry(country)">
                                  <img :src="country.flag" width="20" height="14" class="county-flag" />
                                  {{ country.name }}
                                </a>
                              </li>
                            </ul>
                          </template>
                        </div>
                      </div>
                      <div v-else class="dropdown-wrapper">
                        <GFMP
                          v-for="i in 6"
                          :key="i"
                          :styles="{
                            minHeight: '26px',
                            width: '100%',
                            marginBottom: '10px',
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Brand image</label>
                  <div class="input-box">
                    <div class="input-image" :class="{ filled: imageBrand }">
                      <img :src="imageBrand ? imageBrand : `/assets/img/add-photo-new.png`" height="100" width="100" />
                      <a href="" class="input-image__form" @click.prevent="openModalUploadImage"></a>
                      <a v-if="imageBrand" href="" class="input-image__clear" @click.prevent="clearImageBrand">
                        <img src="/assets/img/icons/clear.svg" height="18" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-fix-bottom">
              <div class="col-xs-12">
                <button
                  type="button"
                  class="btn red btn-block btn-next"
                  :class="{ disabled: isNextDisabled || isLoadingSubmitBrand }"
                  @click.prevent="update('edit_brand')"
                >
                  SAVE
                </button>
              </div>
            </div>
          </form>
        </div>

        <div v-if="section === 'add_product_detail'" class="section-add-product-detail section-default">
          <h2 class="heading hidden-mobile">Product Detail</h2>

          <p class="text-helped">Please add more detail about the product</p>

          <form class="form--input-uniform form--add-product-detail">
            <div class="row">
              <div class="col-md-12 col-xs-12 col-universal mb-30">
                <div class="input-row">
                  <label class="form-label">Product Name <span class="input-mandatory">*</span></label>
                  <div v-click-outside="hideProductOptions" class="input-box">
                    <input
                      id="productname"
                      v-model="form.product.name"
                      v-validate="'required|min:3'"
                      type="text"
                      class="default"
                      name="product name"
                      placeholder="Input Product Name"
                      autocomplete="off"
                      @keyup.exact="onKeyupProduct"
                      @blur="cancelSearch()"
                    />
                    <!-- <span class="icon dropdown"></span> -->
                    <ul v-if="options.products && options.products.length > 0" class="dropdown--selectbox">
                      <li
                        v-for="(product, i) in options.products"
                        :key="i"
                        @click.prevent="redirectProduct(product)"
                        @enter="selectProduct(product)"
                      >
                        {{ product.name }}
                      </li>
                    </ul>
                    <p v-show="errors.has('product name')" class="text-error">
                      {{ errors.first('product name') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="form-label">Product Category <span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <input
                      v-model="selectedCategory"
                      type="text"
                      class="default"
                      placeholder="Select category"
                      :readonly="isReadOnlyInputCategory"
                      autocomplete="off"
                      @focus="onFocusCategory"
                      @blur="cancelSearch()"
                    />
                    <span class="icon dropdown"></span>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Description</label>
                  <div class="input-box">
                    <textarea
                      v-model="form.product.description"
                      data-vvdescription-name
                      name="product description"
                      placeholder="Write description of the product..."
                    ></textarea>
                    <p v-show="errors.has('product description')" class="text-error">
                      {{ errors.first('product description') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Product image<span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <div class="input-image" :class="{ filled: imageProduct }">
                      <img
                        :src="imageProduct ? imageProduct : `/assets/img/add-photo-new.png`"
                        height="100"
                        width="100"
                      />
                      <a href="" class="input-image__form" @click.prevent="openModalUploadImage"></a>
                      <a v-if="imageProduct" href="" class="input-image__clear" @click.prevent="clearImageProduct">
                        <img src="/assets/img/icons/clear.svg" height="18" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-fix-bottom">
              <div class="col-xs-12">
                <button
                  type="button"
                  class="btn red btn-block btn-next"
                  :class="{ disabled: isNextDisabled }"
                  @click.prevent="next"
                >
                  NEXT
                </button>
              </div>
            </div>
          </form>
        </div>

        <div v-if="section === 'edit_product_detail'" class="section-add-product-detail section-default">
          <h2 class="heading hidden-mobile">Edit Product Detail</h2>

          <p class="text-helped">Please add more detail about the product</p>

          <form class="form--input-uniform form--add-product-detail">
            <div class="row">
              <div class="col-md-12 col-xs-12 col-universal mb-30">
                <div class="input-row">
                  <label class="form-label">Product Name <span class="input-mandatory">*</span></label>
                  <div v-click-outside="hideProductOptions" class="input-box">
                    <input
                      id="productname"
                      v-model="form.product.name"
                      v-validate="'required|min:3'"
                      type="text"
                      class="default"
                      name="product name"
                      placeholder="Input Product Name"
                      autocomplete="off"
                      @keyup.exact="onKeyupProduct"
                      @blur="cancelSearch()"
                    />
                    <!-- <span class="icon dropdown"></span> -->
                    <ul v-if="options.products && options.products.length > 0" class="dropdown--selectbox">
                      <li
                        v-for="(product, i) in options.products"
                        :key="i"
                        @click.prevent="redirectProduct(product)"
                        @enter="selectProduct(product)"
                      >
                        {{ product.name }}
                      </li>
                    </ul>
                    <p v-show="errors.has('product name')" class="text-error">
                      {{ errors.first('product name') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="form-label">Product Category <span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <input
                      v-model="selectedCategory"
                      type="text"
                      class="default"
                      placeholder="Select category"
                      :readonly="isReadOnlyInputCategory"
                      autocomplete="off"
                      @focus="onFocusCategory"
                      @blur="cancelSearch()"
                    />
                    <span class="icon dropdown"></span>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Description</label>
                  <div class="input-box">
                    <textarea
                      v-model="form.product.description"
                      data-vvdescription-name
                      name="product description"
                      placeholder="Write description of the product..."
                    ></textarea>
                    <p v-show="errors.has('product description')" class="text-error">
                      {{ errors.first('product description') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-universal mb-16">
                <div class="input-row">
                  <label class="with-counter">Product image<span class="input-mandatory">*</span></label>
                  <div class="input-box">
                    <div class="input-image" :class="{ filled: imageProduct }">
                      <img
                        :src="imageProduct ? imageProduct : `/assets/img/add-photo-new.png`"
                        height="100"
                        width="100"
                      />
                      <a href="" class="input-image__form" @click.prevent="openModalUploadImage"></a>
                      <a v-if="imageProduct" href="" class="input-image__clear" @click.prevent="clearImageProduct">
                        <img src="/assets/img/icons/clear.svg" height="18" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row row-fix-bottom">
              <div class="col-xs-12">
                <button
                  type="button"
                  class="btn red btn-block btn-next"
                  :class="{ disabled: isNextDisabled }"
                  @click.prevent="update('edit_product_detail')"
                >
                  SAVE
                </button>
              </div>
            </div>
          </form>
        </div>

        <div v-if="section === 'add_attribute'" class="section-add-attribute section-default">
          <h2 class="heading hidden-mobile">Product {{ attributeName.replace(/_/, ' ') | ucwords }}</h2>
          <p class="text-helped">You may add up to 5 {{ attributeName.replace(/_/, ' ') }}s</p>

          <div v-if="attributeName !== 'multiple_combination'">
            <form class="form--input-uniform form--add-attribute">
              <div class="row">
                <div
                  v-for="(attribute, key) in attributes[attributeName]"
                  :key="key"
                  class="col-xs-12 col-sm-6 col-universal mb-16"
                >
                  <div class="box box-attribute">
                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label"
                        >{{ attributeName | ucfirst }} Name <span class="input-mandatory">*</span></label
                      >
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="attributes[attributeName][key].data"
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="options[attributeName][key]"
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="true"
                          :taggable="true"
                          :tag-placeholder="''"
                          @tag="addOption"
                          @search-change="searchAttribute"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                      </div>
                    </div>

                    <div class="input-row">
                      <label class="with-counter"
                        >{{ attributeName | ucfirst }} Image<span class="input-mandatory">*</span></label
                      >
                      <div class="input-box">
                        <div
                          v-if="!attribute.images.url"
                          class="input-image"
                          :class="{ filled: attribute.images.url }"
                          @click="openModalUploadImage(key)"
                        >
                          <img src="/assets/img/add-photo-new.png" height="100" width="100" />
                        </div>
                        <div v-else class="input-image filled">
                          <img :src="attribute.images.url" height="100" width="100" />
                          <a
                            v-if="attribute.images.url"
                            href=""
                            class="input-image__clear"
                            @click.prevent="clearImageAttribute(key)"
                          >
                            <img src="/assets/img/icons/clear.svg" height="18" />
                          </a>
                        </div>
                      </div>
                    </div>

                    <a
                      v-if="$SO.size(attributes[attributeName]) > 1"
                      href=""
                      class="box-attribute__remove"
                      @click.prevent="removeAttribute(key)"
                    >
                      <img src="/assets/img/icons/trash.svg" height="13" />Remove
                    </a>
                  </div>
                </div>

                <div v-if="$SO.size(attributes[attributeName]) < 5" class="col-xs-12 col-sm-6 col-universal mb-16">
                  <div class="box box-action">
                    <a href="" class="box-action__text" @click.prevent="addMoreCombination">+ add more combination</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-else>
            <form class="form--input-uniform form--add-multiple-attribute">
              <div class="row">
                <div
                  v-for="(combination, key) in multiple_combination"
                  :key="key"
                  class="col-xs-12 col-sm-6 col-universal mb-16"
                >
                  <div class="box box-attribute box-attribute--multiple-combination">
                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Category <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="multiple_combination_category[key].combination[0].name"
                          :disabled="multiple_combination_category[key].combination[0].isDisabled"
                          placeholder="Select category"
                          open-direction="bottom"
                          :options="
                            multiple_combination_options.filter(
                              (x) => x !== multiple_combination_category[key].combination[1].name
                            )
                          "
                          :searchable="false"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="false"
                        >
                        </multiselect>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Name <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="`${key}_0`"
                          v-model="
                            multiple_combination[key].attributes[
                              multiple_combination_category[key].combination[0].name
                                ? multiple_combination_category[key].combination[0].name
                                : 'default'
                            ].data
                          "
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="
                            options[
                              multiple_combination_category[key].combination[0].name
                                ? multiple_combination_category[key].combination[0].name
                                : 'default'
                            ][key]
                          "
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="true"
                          :disabled="!multiple_combination_category[key].combination[0].name"
                          :taggable="true"
                          :tag-placeholder="''"
                          @search-change="searchAttribute"
                          @tag="addOption"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Category <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="multiple_combination_category[key].combination[1].name"
                          :disabled="multiple_combination_category[key].combination[1].isDisabled"
                          placeholder="Select category"
                          open-direction="bottom"
                          :options="
                            multiple_combination_options.filter(
                              (x) => x !== multiple_combination_category[key].combination[0].name
                            )
                          "
                          :searchable="false"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="false"
                        >
                        </multiselect>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Name <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="`${key}_1`"
                          v-model="
                            multiple_combination[key].attributes[
                              multiple_combination_category[key].combination[1].name
                                ? multiple_combination_category[key].combination[1].name
                                : 'default'
                            ].data
                          "
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="
                            options[
                              multiple_combination_category[key].combination[1].name
                                ? multiple_combination_category[key].combination[1].name
                                : 'default'
                            ][key]
                          "
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="true"
                          :disabled="!multiple_combination_category[key].combination[1].name"
                          :taggable="true"
                          :tag-placeholder="''"
                          @search-change="searchAttribute"
                          @tag="addOption"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                      </div>
                    </div>

                    <div class="input-row">
                      <label class="with-counter">Variant Image<span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <div
                          v-if="!combination.attributes.images.url"
                          class="input-image"
                          @click="openModalUploadImage(key)"
                        >
                          <img src="/assets/img/add-photo-new.png" height="100" width="100" />
                        </div>
                        <div v-else class="input-image filled">
                          <img :src="combination.attributes.images.url" height="100" width="100" />
                          <a
                            v-if="combination.attributes.images.url"
                            href=""
                            class="input-image__clear"
                            @click.prevent="clearImageAttribute(key)"
                          >
                            <img src="/assets/img/icons/clear.svg" height="18" />
                          </a>
                        </div>
                      </div>
                    </div>

                    <a
                      v-if="$SO.size(multiple_combination) > 1"
                      href=""
                      class="box-attribute__remove"
                      @click.prevent="removeAttribute(key)"
                    >
                      <img src="/assets/img/icons/trash.svg" height="13" />Remove
                    </a>
                  </div>
                </div>

                <div v-if="$SO.size(multiple_combination) < 5" class="col-xs-12 col-sm-6 col-universal mb-16">
                  <div class="box box-action">
                    <a href="" class="box-action__text" @click.prevent="addMoreMultipleCombination"
                      >+ add more combination</a
                    >
                    <p v-if="isErrorAddMoreCombination" class="text-error">
                      {{ message }}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="row row-fix-bottom">
            <div class="col-xs-12">
              <button
                type="button"
                class="btn red btn-next--attribute btn-next"
                :class="{ disabled: isNextDisabled }"
                @click.prevent="next"
              >
                NEXT
              </button>
            </div>
          </div>
        </div>

        <div v-if="section === 'edit_attribute'" class="section-add-attribute section-default">
          <h2 class="heading hidden-mobile">Edit Product {{ attributeName.replace(/_/, ' ') | ucwords }}</h2>
          <p class="text-helped text-center">You may add up to 5 {{ attributeName.replace(/_/, ' ') }}s</p>

          <div v-if="attributeName !== 'multiple_combination'">
            <form class="form--input-uniform form--add-attribute">
              <div class="row">
                <div
                  v-for="(attribute, key) in attributes[attributeName]"
                  :key="key"
                  class="col-xs-12 col-universal col-sm-6 mb-16"
                >
                  <div class="box box-attribute">
                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label"
                        >{{ attributeName | ucfirst }} Name <span class="input-mandatory">*</span></label
                      >
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="attributes[attributeName][key].data"
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="options[attributeName][key]"
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="true"
                          @search-change="searchAttribute"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                        <p v-show="errors.has(`attribute_${key}`)" class="text-error">
                          {{ errors.first(`attribute_${key}`) }}
                        </p>
                      </div>
                    </div>

                    <div class="input-row">
                      <label class="with-counter"
                        >{{ attributeName | ucfirst }} Image<span class="input-mandatory">*</span></label
                      >
                      <div class="input-box">
                        <div
                          v-if="!attribute.images.url"
                          class="input-image"
                          :class="{ filled: attribute.images.url }"
                          @click="openModalUploadImage(key)"
                        >
                          <img src="/assets/img/add-photo-new.png" height="100" width="100" />
                        </div>
                        <div v-else class="input-image filled">
                          <img
                            :src="attribute.images.url"
                            height="100"
                            width="100"
                            @click="openModalUploadImage(key)"
                          />
                          <a
                            v-if="attribute.images.url"
                            href=""
                            class="input-image__clear"
                            @click.prevent="clearImageAttribute(key)"
                          >
                            <img src="/assets/img/icons/clear.svg" height="18" />
                          </a>
                        </div>
                      </div>
                    </div>

                    <a
                      v-if="$SO.size(attributes[attributeName]) > 1"
                      href=""
                      class="box-attribute__remove"
                      @click.prevent="removeAttribute(key)"
                    >
                      <img src="/assets/img/icons/trash.svg" height="13" />Remove
                    </a>
                  </div>
                </div>

                <div v-if="$SO.size(attributes[attributeName]) < 5" class="col-xs-12 col-universal col-sm-6 mb-16">
                  <div class="box box-action">
                    <a href="" class="box-action__text" @click.prevent="addMoreCombination">+ add more combination</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-else>
            <form class="form--input-uniform form--add-multiple-attribute">
              <div class="row">
                <div
                  v-for="(combination, key) in multiple_combination"
                  :key="key"
                  class="col-xs-12 col-sm-6 col-universal mb-16"
                >
                  <div class="box box-attribute box-attribute--multiple-combination">
                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Category <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="multiple_combination_category[key].combination[0].name"
                          :disabled="multiple_combination_category[key].combination[1].isDisabled"
                          placeholder="Select category"
                          open-direction="bottom"
                          :options="multiple_combination_options"
                          :searchable="false"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="false"
                        >
                        </multiselect>
                        <p v-show="errors.has(`attribute_${key}`)" class="text-error">
                          {{ errors.first(`attribute_${key}`) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Name <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="`${key}_0`"
                          v-model="
                            multiple_combination[key].attributes[
                              multiple_combination_category[key].combination[0].name
                                ? multiple_combination_category[key].combination[0].name
                                : 'default'
                            ].data
                          "
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="
                            options[
                              multiple_combination_category[key].combination[0].name
                                ? multiple_combination_category[key].combination[0].name
                                : 'default'
                            ][key]
                          "
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :taggable="true"
                          :show-labels="false"
                          :hide-selected="true"
                          :disabled="!multiple_combination_category[key].combination[0].name"
                          tag-placeholder="Press Enter To Create Name"
                          @search-change="searchAttribute"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                        <p v-show="errors.has(`attribute_${key}`)" class="text-error">
                          {{ errors.first(`attribute_${key}`) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Category <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="key"
                          v-model="multiple_combination_category[key].combination[1].name"
                          :disabled="multiple_combination_category[key].combination[1].isDisabled"
                          placeholder="Select category"
                          open-direction="bottom"
                          :options="multiple_combination_options"
                          :searchable="false"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="false"
                        >
                        </multiselect>
                        <p v-show="errors.has(`attribute_${key}`)" class="text-error">
                          {{ errors.first(`attribute_${key}`) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="input-row"
                      :class="{
                        'mb-24': !errors.has(`attribute_${key}`),
                        'mb-20': errors.has(`attribute_${key}`),
                      }"
                    >
                      <label class="form-label">Combination Name <span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <multiselect
                          :id="`${key}_1`"
                          v-model="
                            multiple_combination[key].attributes[
                              multiple_combination_category[key].combination[1].name
                                ? multiple_combination_category[key].combination[1].name
                                : 'default'
                            ].data
                          "
                          label="name"
                          track-by="_id"
                          :placeholder="placeholderInputAttribute"
                          open-direction="bottom"
                          :options="
                            options[
                              multiple_combination_category[key].combination[1].name
                                ? multiple_combination_category[key].combination[1].name
                                : 'default'
                            ][key]
                          "
                          :searchable="true"
                          :loading="isLoadingAttribute"
                          :internal-search="false"
                          :clear-on-select="false"
                          :close-on-select="true"
                          :options-limit="300"
                          :max-height="400"
                          :show-no-results="true"
                          :show-labels="false"
                          :hide-selected="true"
                          :disabled="!multiple_combination_category[key].combination[1].name"
                          @search-change="searchAttribute"
                        >
                          <span slot="noResult"></span>
                          <span slot="noOptions"></span>
                        </multiselect>
                        <p v-show="errors.has(`attribute_${key}`)" class="text-error">
                          {{ errors.first(`attribute_${key}`) }}
                        </p>
                      </div>
                    </div>

                    <div class="input-row">
                      <label class="with-counter">Variant Image<span class="input-mandatory">*</span></label>
                      <div class="input-box">
                        <div
                          v-if="!combination.attributes.images.url"
                          class="input-image"
                          @click="openModalUploadImage(key)"
                        >
                          <img src="/assets/img/add-photo-new.png" height="100" width="100" />
                        </div>
                        <div v-else class="input-image filled">
                          <img :src="combination.attributes.images.url" height="100" width="100" />
                          <a
                            v-if="combination.attributes.images.url"
                            href=""
                            class="input-image__clear"
                            @click.prevent="clearImageAttribute(key)"
                          >
                            <img src="/assets/img/icons/clear.svg" height="18" />
                          </a>
                        </div>
                      </div>
                    </div>

                    <a
                      v-if="$SO.size(multiple_combination) > 1"
                      href=""
                      class="box-attribute__remove"
                      @click.prevent="removeAttribute(key)"
                    >
                      <img src="/assets/img/icons/trash.svg" height="13" />Remove
                    </a>
                  </div>
                </div>

                <div v-if="$SO.size(multiple_combination) < 5" class="col-xs-12 col-sm-6 col-universal mb-16">
                  <div class="box box-action">
                    <a href="" class="box-action__text" @click.prevent="addMoreMultipleCombination"
                      >+ add more combination</a
                    >
                    <p v-if="isErrorAddMoreCombination" class="text-error">
                      {{ message }}
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="row row-fix-bottom">
            <div class="col-xs-12">
              <button
                type="button"
                class="btn red btn-next--attribute btn-next"
                :class="{ disabled: isNextDisabled }"
                @click.prevent="update('edit_attribute')"
              >
                SAVE
              </button>
            </div>
          </div>
        </div>

        <div v-if="section === 'summary'" class="section-summary section-default">
          <h2 class="heading hidden-mobile">Summary</h2>
          <p class="text-helped text-center">
            <img src="/assets/img/icons/summary.svg" height="24" /> Periksa kembali data produk sebelum disubmit.
          </p>

          <div v-if="form.region.name" class="summary-section summary-section-brand">
            <h4 class="summary-section__heading">
              New Brand
              <a href="" class="summary-section__action" @click.prevent="redirectToEditBrand"
                ><img src="/assets/img/icons/edit.svg" /> Edit</a
              >
            </h4>

            <div class="summary-section__head">
              <div class="summary-section__head__thumb">
                <img
                  :src="`${imageBrand ? imageBrand : '/assets/img/dummy_product.svg'}`"
                  height="64"
                  width="64"
                  class="summary-section__image"
                />
              </div>
              <div class="summary-section__head__info">
                <h2 class="summary-section__head__heading">
                  {{ form.brand.name }}
                </h2>
                <p class="summary-section__head__text">
                  <img :src="form.country.flag" class="summary-section-brand__country-flag" width="23" height="16" />
                  {{ form.country.name }}
                </p>
              </div>
            </div>

            <div class="summary-section__body">
              <p v-if="form.brand.description" class="summary-section__description">
                {{ form.brand.description }}
              </p>
            </div>
          </div>

          <div class="summary-section summary-section-product">
            <h4 class="summary-section__heading">
              New Product
              <a href="" class="summary-section__action" @click.prevent="redirectToEditProduct"
                ><img src="/assets/img/icons/edit.svg" /> Edit</a
              >
            </h4>

            <div class="summary-section__head">
              <div class="summary-section__head__thumb">
                <img
                  :src="`${imageProduct ? imageProduct : '/assets/img/dummy_product.svg'}`"
                  height="64"
                  width="64"
                  class="summary-section__image"
                />
              </div>
              <div class="summary-section__head__info">
                <h2 class="summary-section__head__heading">
                  {{ form.brand.name }}
                </h2>
                <p class="summary-section__head__text">
                  {{ form.product.name }}
                </p>
              </div>
            </div>

            <div class="summary-section__body">
              <p v-if="form.product.description" class="summary-section__description">
                {{ form.product.description }}
              </p>
            </div>
          </div>

          <div v-if="$SO.size(productCombination)" class="summary-section summary-section-combination">
            <h4 class="summary-section__heading">
              Product Combination ({{ $SO.size(productCombination) }})
              <a href="" class="summary-section__action" @click.prevent="redirectToEditCombination"
                ><img src="/assets/img/icons/edit.svg" /> Edit</a
              >
            </h4>

            <ul class="list-summary-combination">
              <li v-for="(combination, key) in productCombination" :key="`list-summary-combination-${key}`">
                <img
                  :src="`${combination.images.url ? combination.images.url : '/assets/img/dummy_product.svg'}`"
                  height="32"
                  width="32"
                  class="list-summary-combination__img"
                />
                <span class="list-summary-combination__name">{{ combination.data.name }}</span>
              </li>
            </ul>
          </div>

          <div class="row row-fix-bottom">
            <div class="col-xs-12">
              <button type="button" class="btn red btn-next--attribute btn-next" @click.prevent="next">
                ADD PRODUCT
              </button>
            </div>
          </div>
        </div>

        <div v-if="section === 'success'" class="section-success section-default">
          <img src="/assets/img/icons/success-add-product.svg" class="section-success__img" />
          <p class="section-success__heading">Data produk telah dimasukkan</p>
          <p class="section-success__text">
            Kamu telah sukses menambahkan produk. Data produk akan dikurasi terlebih dahulu oleh tim kami. Terima kasih.
          </p>
          <div class="row row-fix-bottom">
            <div class="col-xs-12">
              <router-link class="btn minimalist btn-back-to-home" to="/"> BACK TO HOME </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalProductExisted />
    <ModalSelectCategory v-if="showModalSelectCategory" />
    <ModalProductCombination @getAttribute="getAttribute" @next="setSection" />
    <ModalUploadImage v-if="isShowModalUploadImage" @closeModal="closeModalUploadImage" @saveFile="saveImageUpload" />
    <ModalDiscard @discard="backStep" />
  </div>
</template>

<script>
let CancelToken;
let source;
import Multiselect from 'vue-multiselect';
import ClickOutside from 'vue-click-outside';
import ModalUploadImage from './snippet/modal-upload-image';
import ModalDiscard from './snippet/modal-discard';
import ModalProductExisted from '@/components/global/modal/modal-product-existed';
import ModalSelectCategory from '@/components/global/modal/modal-select-category';
import ModalProductCombination from '@/components/global/modal/modal-product-combination';

export default {
  name: 'add-product-page',
  components: {
    Multiselect,
    ModalUploadImage,
    ModalProductExisted,
    ModalSelectCategory,
    ModalProductCombination,
    ModalDiscard,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      activeKeyUploadImage: '',
      alphabets: [
        '#',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
      combinationImage: '',
      defaultCombinationNamePick: '',
      listCombinationGroup: [
        {
          combinationCategory: '',
          combinationImage: '',
          combinationImageName: '',
          combinationName: '',
          combinationId: '',
          isDefaultCombination: true,
          isSelectReadOnly: false,
          isProcessingSearch: false,
          options: [],
        },
      ],
      isDisabledInputProductName: true,
      isShowModalUploadImage: false,
      isErrorAddMoreCombination: false,
      form: {
        country: {
          name: '',
        },
        region: {
          name: '',
        },
        brand: {
          _id: null,
          id: null,
          name: null,
          description: null,
        },
        product: {
          name: null,
          categories: [],
          description: null,
          how_to_use: null,
          ingredients: null,
          attributes: {
            size: null,
            variant: null,
            shade: null,
          },
        },
      },
      options: {
        brands: null,
        products: null,
        size: [[], [], [], [], []],
        variant: [[], [], [], [], []],
        shade: [[], [], [], [], []],
        region: [],
        country: [],
        default: [[], [], [], [], []],
      },
      selectedProduct: null,
      tempProd: [],
      tempBrands: [],
      isBrandNotFound: false,
      section: 'add_product',
      isOpenCountryDropdown: false,
      isOpenRegionDropdown: false,
      isOpenMegaMenuBrands: false,
      isLoadingAttribute: false,
      isLoadingCountry: false,
      isLoadingMegeMenuBrands: false,
      isLoadingRegion: false,
      isLoadingSubmitBrand: false,
      isReadOnlyInputCountry: false,
      isReadOnlyInputCategory: false,
      isReadOnlyInputProductName: false,
      isReadOnlyInputRegion: false,
      imageBrand: '',
      imageProduct: '',
      attributeName: '',
      attributes: {
        shade: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
        variant: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
        size: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
      },
      multiple_combination: [
        {
          attributes: {
            default: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            shade: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            size: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            variant: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            images: {
              is_cover: true,
              url: '',
            },
          },
        },
      ],
      multiple_combination_category: [
        {
          combination: [
            {
              name: '',
              isDisabled: false,
            },
            {
              name: '',
              isDisabled: false,
            },
          ],
        },
      ],
      multiple_combination_options: ['shade', 'size', 'variant'],
      searchBrandValue: '',
      searchCountryValue: '',
      searchRegionValue: '',
      brandsFilters: {},
      message: '',
    };
  },
  computed: {
    windowHeight() {
      return this.$store.state.screen.height;
    },
    brands: {
      cache: false,
      get() {
        return this.$SO.size(this.filterBrands) || this.searchBrandValue ? this.filterBrands : this.$store.state.brands;
      },
    },
    isNextDisabled() {
      if (this.section === 'add_product') {
        return !this.form.brand.name || !this.form.product.name;
      } else if (this.section === 'add_product_detail' || this.section === 'edit_product_detail') {
        return !this.imageProduct || !this.selectedCategory || !this.form.product.name;
      } else if (this.section === 'add_brand' || this.section === 'edit_brand') {
        return !this.form.brand.name || !this.form.region.name || !this.form.country.name;
      } else if (this.section === 'add_attribute' || this.section === 'edit_attribute') {
        if (this.attributeName !== 'multiple_combination') {
          return !this.attributes[this.attributeName][0].data || !this.attributes[this.attributeName][0].images.url;
        }

        return (
          !this.multiple_combination_category[0].combination[0].name ||
          !this.multiple_combination[0].attributes[
            this.multiple_combination_category[0].combination[0].name
              ? this.multiple_combination_category[0].combination[0].name
              : 'default'
          ].data ||
          !this.multiple_combination_category[0].combination[1].name ||
          !this.multiple_combination[0].attributes[
            this.multiple_combination_category[0].combination[1].name
              ? this.multiple_combination_category[0].combination[1].name
              : 'default'
          ].data ||
          !this.multiple_combination[0].attributes.images.url
        );
      }
      return false;
    },
    isAllowedAddCombinationGroup() {
      return this.$SO.size(this.listCombinationGroup) < 5;
    },
    isVerifiedPhone() {
      const userProfile = this.$store.state.userProfile;
      return userProfile && 'is_verified_phone' in userProfile ? userProfile.is_verified_phone : false;
    },
    loggedin() {
      return this.$store.state.auth.loggedin;
    },
    hideBackStep() {
      if (this.screen.isDesktop) {
        return this.section !== 'add_product' && this.section !== 'success';
      }
      return this.section !== 'success';
    },
    newBrand() {
      return this.$store.state.addProduct.newBrand;
    },
    placeholderInputAttribute() {
      if (this.attributeName === 'shade') {
        return 'Input shade name (ex: Red Velvet)';
      } else if (this.attributeName === 'size') {
        return 'Input size name (ex: 100 ml)';
      } else if (this.attributeName === 'variant') {
        return 'Input variant name (ex: Watermelon)';
      } else if (this.attributeName === 'multiple_combination') {
        return 'Input combination name';
      } else {
        return '';
      }
    },
    productCombination() {
      let singleAttributeSelected = false;
      // const multipleAttributeSelected = false;
      let productCombination;

      this.$SO.each(this.attributes, (combinationName, listCombination) => {
        if (this.attributes[combinationName][0].data) {
          singleAttributeSelected = true;
          productCombination = this.attributes[combinationName];
        }
      });

      // if single combination is null
      if (!singleAttributeSelected) {
        productCombination = [];
        this.$SO.each(this.multiple_combination, (key, listAttributes) => {
          let attributeName = '';
          let images;
          this.$SO.each(listAttributes.attributes, (combinationName, combination) => {
            if (listAttributes.attributes[combinationName].data) {
              if (attributeName) {
                attributeName += ', ';
              }
              attributeName += `${combinationName.toUpperCase()}: ${
                listAttributes.attributes[combinationName].data.name
              }`;
              images = listAttributes.attributes.images;
            }
          });

          if (attributeName) {
            productCombination.push({
              data: {
                name: attributeName,
              },
              images: images,
            });
          }
        });
      }

      return productCombination;
    },
    screen() {
      return this.$store.state.screen;
    },
    showModalSelectCategory() {
      return this.$store.state.modal.isModalShow.selectCategory;
    },
    selectedCategory() {
      const lastIndex = this.$SO.size(this.$store.state.addProduct.categories) - 1;
      if (this.$SO.size(this.$store.state.addProduct.categories)) {
        return this.$store.state.addProduct.categories[lastIndex].name;
      }
      return '';
    },
    textHeaderMobile() {
      if (this.section === 'add_product') {
        return 'ADD PRODUCT';
      } else if (this.section === 'add_brand') {
        return 'ADD NEW BRAND';
      } else if (this.section === 'add_product_detail') {
        return 'PRODUCT DETAIL';
      } else if (this.section === 'add_attribute') {
        return `PRODUCT ${this.attributeName.replace(/_/, ' ').toUpperCase()}`;
      } else if (this.section === 'summary') {
        return 'SUMMARY';
      } else if (this.section === 'edit_product_detail') {
        return 'EDIT PRODUCT DETAIL';
      } else if (this.section === 'edit_brand') {
        return 'EDIT BRAND';
      } else if (this.section === 'edit_attribute') {
        return `EDIT PRODUCT ${this.attributeName.replace(/_/, ' ').toUpperCase()}`;
      }
      return '';
    },
  },
  watch: {
    'form.brand.name'(newVal) {
      if (newVal) {
        this.$store.commit('addProduct/setForm', true);
      } else {
        this.$store.commit('addProduct/setForm', false);
      }
    },
    isNextDisabled() {
      if (/attribute/gi.test(this.section)) {
        if (!this.isNextDisabled) {
          this.isErrorAddMoreCombination = false;
        }
      }
    },
    section(value) {
      if (value) {
        if (value === 'add_brand') {
          this.form.brand = {
            _id: null,
            id: null,
            name: null,
            description: null,
          };
          this.getRegion();
          this.getCountry();
        } else if (value === 'success') {
          this.$store.commit('addProduct/setForm', false);
        }
        this.scrollToTop();
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('addProduct/setForm', false);
    this.$store.commit('addProduct/setCategories', '');
    this.$SO('body').removeClass('body--add-product');
  },
  created() {
    if (!this.loggedin) {
      this.$router.push('/');
      return;
    }

    if (!this.screen.isDesktop) {
      this.$SO('body').addClass('body--add-product');
    }
  },
  methods: {
    addBrand() {
      this.section = 'add_brand';
    },
    addMoreCombination() {
      const isMaxAttribute = this.$SO.size(this.attributes[this.attributeName]) === 5 ? true : false;
      if (!isMaxAttribute) {
        this.attributes[this.attributeName].push({
          data: {
            name: '',
          },
          images: {
            is_cover: true,
            url: '',
          },
        });
      }
    },
    addMoreMultipleCombination() {
      const isMaxAttribute = this.$SO.size(this.multiple_combination) === 5 ? true : false;

      if (!isMaxAttribute && !this.isNextDisabled) {
        this.isErrorAddMoreCombination = false;
        this.multiple_combination.push({
          attributes: {
            default: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            shade: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            size: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            variant: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            images: {
              is_cover: true,
              url: '',
            },
          },
        });

        this.multiple_combination_category.push({
          combination: [
            {
              name: this.multiple_combination_category[0].combination[0].name,
              isDisabled: true,
            },
            {
              name: this.multiple_combination_category[0].combination[1].name,
              isDisabled: true,
            },
          ],
        });
      } else {
        if (
          !this.multiple_combination_category[0].combination[0].name ||
          !this.multiple_combination_category[0].combination[1].name
        ) {
          this.message = 'Combination category harus diisi';
        } else if (
          !this.multiple_combination[0].attributes[
            this.multiple_combination_category[0].combination[0].name
              ? this.multiple_combination_category[0].combination[0].name
              : 'default'
          ].data ||
          !this.multiple_combination[0].attributes[
            this.multiple_combination_category[0].combination[1].name
              ? this.multiple_combination_category[0].combination[1].name
              : 'default'
          ].data
        ) {
          this.message = 'Combination name harus diisi';
        } else {
          this.message = 'Variant image harus diisi';
        }
        this.isErrorAddMoreCombination = true;
      }
    },
    addOption(value, key) {
      const keyOption = key;
      let keys;

      const newOption = {
        name: value,
        _id: this.randomString(),
      };

      if (this.attributeName === 'multiple_combination') {
        keys = key.split('_');
        const keyMultipleCombination = Number(keys[0]);
        const keyCombinationCategory = Number(keys[1]);
        const attributeName =
          this.multiple_combination_category[keyMultipleCombination].combination[keyCombinationCategory].name;
        this.options[attributeName][keyMultipleCombination].push(newOption);
        this.multiple_combination[keyMultipleCombination].attributes[attributeName].data = newOption;
      } else {
        this.options[this.attributeName][keyOption].push(newOption);
        this.attributes[this.attributeName][keyOption].data = newOption;
      }
    },
    addValueToInputBrand(brand) {
      this.form.brand = brand;
      this.hideMegaMenuBrands();
    },
    addValueToInputCountry(country) {
      this.form.country = country;
      this.hideCountryDropdown();
    },
    addValueToInputRegion(region) {
      this.form.region = region;
      this.hideRegionDropdown();
    },
    backStep() {
      if (this.section === 'add_product') {
        this.$router.push('/');
      } else if (this.section === 'add_product_detail') {
        this.form.product.description = '';
        this.$store.commit('addProduct/setCategories', '');
        this.imageProduct = '';
        this.section = 'add_product';
      } else if (this.section === 'add_attribute') {
        this.resetCombinationForm();
        this.section = 'add_product_detail';
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'productCombination',
        });
      } else if (this.section === 'add_brand') {
        this.form.brand.name = '';
        this.form.brand.description = '';
        this.form.country = '';
        this.form.region = '';
        this.imageBrand = '';
        this.section = 'add_product';
      } else if (/edit/.test(this.section)) {
        this.section = 'summary';
      } else if (this.section === 'summary') {
        this.resetCombinationForm();
        this.section = 'add_product_detail';
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'productCombination',
        });
      }

      this.$store.commit('toggleModalGlobalState', {
        modalName: 'discardAddProduct',
      });
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    clearImageProduct() {
      this.imageProduct = '';
    },
    clearImageBrand() {
      this.imageBrand = '';
    },
    clearImageAttribute(key) {
      if (this.attributeName !== 'multiple_combination') {
        this.attributes[this.attributeName][key].images.url = '';
      } else {
        this.multiple_combination[key].attributes.images.url = '';
      }
    },
    closeModalUploadImage() {
      this.isShowModalUploadImage = false;
    },
    discard() {
      if (/product_detail/.test(this.section)) {
        if (this.form.product.name || this.selectedCategory || this.form.product.description || this.imageProduct) {
          this.$store.commit('toggleModalGlobalState', {
            modalName: 'discardAddProduct',
          });
        } else {
          this.section = 'add_product';
        }
      } else if (/brand/.test(this.section)) {
        if (
          this.form.brand.name ||
          this.form.brand.description ||
          (this.form.region && this.form.region.name) ||
          (this.form.country && this.form.country.name) ||
          this.imageBrand
        ) {
          this.$store.commit('toggleModalGlobalState', {
            modalName: 'discardAddProduct',
          });
        } else {
          this.section = 'add_product';
        }
      } else if (/attribute/.test(this.section)) {
        if (this.attributeName === 'multiple_combination') {
          if (
            this.multiple_combination_category[0].combination[0].name ||
            this.multiple_combination_category[0].combination[1].name
          ) {
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'discardAddProduct',
            });
          } else {
            this.section = 'add_product_detail';
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'productCombination',
            });
          }
        } else {
          if (this.attributes[this.attributeName][0].data) {
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'discardAddProduct',
            });
          } else {
            this.section = 'add_product_detail';
            this.$store.commit('toggleModalGlobalState', {
              modalName: 'productCombination',
            });
          }
        }
      } else {
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'discardAddProduct',
        });
      }
    },
    fetchAllBrands() {
      if (!this.$SO.size(this.brands)) {
        this.isLoadingMegeMenuBrands = true;
        this.$store.dispatch('getBrands').then(() => {
          this.isLoadingMegeMenuBrands = false;
        });
      }
    },
    getAttribute({ attributeName }) {
      this.section = 'add_attribute';
      this.attributeName = attributeName;
    },
    getCountry() {
      this.isLoadingCountry = true;
      this.$MS_CATALOG_API_URL
        .get(`/tags`, {
          params: {
            filter: {
              level_name: { $in: ['level 2a'] },
            },
            fields: 'name flag',
            skip: 0,
            limit: 0,
            sort: 'name',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const newObjectCountry = {};
            this.$SO.each(response.data.data, (key, country) => {
              const letter = country.name[0].toUpperCase();
              response.data.data[key].isHidden = false;
              if (!newObjectCountry[letter]) {
                newObjectCountry[letter] = [];
              }
              newObjectCountry[letter].push(country);
            });
            this.options.country = newObjectCountry;
          } else {
            this.options.country = [];
          }
          this.isLoadingCountry = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingCountry = false;
          this.options.country = [];
        });
    },
    getRegion() {
      this.isLoadingRegion = true;
      this.$MS_CATALOG_API_URL
        .get(`/tags`, {
          params: {
            filter: {
              level_name: { $in: ['level 2'] },
            },
            fields: 'name',
            skip: 0,
            limit: 0,
            sort: 'created_at',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.$SO.each(response.data.data, (key, region) => {
              response.data.data[key].isHidden = false;
            });
            this.options.region = response.data.data;
          } else {
            this.options.region = [];
          }
          this.isLoadingRegion = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingRegion = false;
          this.options.region = [];
        });
    },
    hideCountryDropdown() {
      this.isOpenCountryDropdown = false;
      this.isReadOnlyInputCountry = false;
    },
    hideProductOptions() {
      this.options.products = null;
    },
    hideMegaMenuBrands() {
      this.isOpenMegaMenuBrands = false;
      this.isReadOnlyInputProductName = false;
    },
    hideRegionDropdown() {
      this.isOpenRegionDropdown = false;
      this.isReadOnlyInputRegion = false;
    },
    next() {
      if (this.section === 'add_product') {
        this.verifyProduct();
      } else if (this.section === 'add_product_detail') {
        this.$store.commit('toggleModalGlobalState', {
          modalName: 'productCombination',
        });
      } else if (this.section === 'add_attribute') {
        this.section = 'summary';
      } else if (this.section === 'add_brand') {
        this.submitBrand();
      } else if (this.section === 'summary') {
        this.submitAddProduct();
      }
    },
    onKeyupProduct() {
      if (!this.form.product.name || this.form.product.name.length <= 2) {
        this.cancelSearch();
        return;
      }

      if (typeof this.cancelSource !== 'undefined') {
        this.cancelSearch();
      }
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();

      const keywords = this.form.product.name;
      const brandId = this.form.brand.my_soco_sql_id;

      if (brandId && this.form.product.name.length > 2) {
        this.tempProd = [];
        this.$MS_SOCO_PUBLIC_API_URL
          .get(`/products`, {
            params: {
              filter: {
                name: { $regex: keywords, $options: 'i' },
                'brand.my_soco_sql_id': brandId,
              },
            },
          })
          .then((res) => {
            if (res.status == 200) {
              this.options.products = res.data.data;
              this.tempProd = res.data.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    onFocusBrands() {
      this.showMegaMenuBrands();
      this.fetchAllBrands();
    },
    onFocusCategory() {
      this.showMegaMenuCategories();
    },
    onFocusCountry() {
      this.showCountryDropdown();
    },
    onFocusRegion() {
      this.showRegionDropdown();
    },
    openModalUploadImage(key) {
      this.isShowModalUploadImage = true;
      this.activeKeyUploadImage = key;
    },
    randomString() {
      let result = '';
      const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      for (let i = 32; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
      return result;
    },
    redirectProduct(product) {
      this.$router.push(`/review/add/${product.id}`);
    },
    redirectToEditCombination() {
      this.section = 'edit_attribute';
    },
    redirectToEditBrand() {
      this.section = 'edit_brand';
    },
    redirectToEditProduct() {
      this.section = 'edit_product_detail';
    },
    removeAttribute(key) {
      if (this.attributeName === 'multiple_combination') {
        this.multiple_combination.splice(key, 1);
      } else {
        this.attributes[this.attributeName].splice(key, 1);
      }
    },
    resetAttributeSearch(e, key) {
      this.listCombinationGroup[key].options = '';
    },
    resetCombinationForm() {
      this.attributes = {
        shade: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
        variant: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
        size: [
          {
            data: '',
            images: {
              is_cover: true,
              url: '',
            },
          },
        ],
      };

      this.multiple_combination = [
        {
          attributes: {
            default: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            shade: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            size: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            variant: {
              data: '',
              images: {
                is_cover: true,
                url: '',
              },
            },
            images: {
              is_cover: true,
              url: '',
            },
          },
        },
      ];

      this.multiple_combination_category = [
        {
          combination: [
            {
              name: '',
            },
            {
              name: '',
            },
          ],
        },
      ];

      this.options.size = [[], [], [], [], []];
      this.options.variant = [[], [], [], [], []];
      this.options.shade = [[], [], [], [], []];
    },
    saveImageUpload({ fileBase64String, fileName }) {
      if (this.section === 'add_brand' || this.section === 'edit_brand') {
        this.imageBrand = fileBase64String;
      } else if (this.section === 'add_product_detail' || this.section === 'edit_product_detail') {
        this.imageProduct = fileBase64String;
      } else if (this.section === 'add_attribute' || this.section === 'edit_attribute') {
        if (this.attributeName !== 'multiple_combination') {
          this.attributes[this.attributeName][this.activeKeyUploadImage].images.url = fileBase64String;
        } else {
          this.multiple_combination[this.activeKeyUploadImage].attributes.images.url = fileBase64String;
        }
      }

      this.closeModalUploadImage();
    },
    scrollToSpecificBrand(id) {
      const topPos = document.getElementById(id).offsetTop;
      const containerOffset = document.getElementById('addProductListBrands').offsetTop;
      document.getElementById('addProductListBrands').scrollTop = topPos - containerOffset;
    },
    scrollToSpecificCountry(id) {
      const topPos = document.getElementById(id).offsetTop;
      const containerOffset = document.getElementById('dropdownCountry').offsetTop;
      document.getElementById('dropdownCountry').scrollTop = topPos - containerOffset;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    selectProduct(product) {
      this.selectedProduct = product;
      this.form.product.name = product.name;
      this.cancelSearch();
      this.options.products = null;
    },
    searchAttribute(query, key) {
      let attributeName;
      let keyMultipleCombination;
      let keyCombinationCategory;
      let keys;
      let keyOptions;

      if (this.attributeName === 'multiple_combination') {
        keys = key.split('_');
        keyMultipleCombination = Number(keys[0]);
        keyCombinationCategory = Number(keys[1]);
        attributeName =
          this.multiple_combination_category[keyMultipleCombination].combination[keyCombinationCategory].name;
      } else {
        attributeName = this.attributeName;
      }

      if (!query) {
        if (typeof source !== 'undefined') {
          this.isLoadingAttribute = false;
          source.cancel();
        }
        return;
      }

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      this.isLoadingAttribute = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/product/attributes`, {
          params: {
            filter: {
              'group.name': this.$options.filters.ucfirst(attributeName),
              name: { $regex: '^' + query, $options: 'i' },
            },
          },
          cancelToken: source.token,
        })
        .then((response) => {
          keyOptions = this.attributeName === 'multiple_combination' ? keyMultipleCombination : key;
          if (response.status === 200) {
            this.options[attributeName][keyOptions] = response.data.data;
          } else {
            this.options[attributeName][keyOptions] = [];
          }
          this.isLoadingAttribute = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingAttribute = false;
          this.options[attributeName][keyOptions] = [];
        });
    },
    searchBrand() {
      if (this.searchBrandValue) {
        const searchResult = {};
        Object.keys(this.$store.state.brands).map((alphabet) => {
          this.$store.state.brands[alphabet].forEach((brand) => {
            if (brand.name.toLowerCase().indexOf(this.searchBrandValue.toLowerCase()) > -1) {
              if (!searchResult[alphabet]) {
                searchResult[alphabet] = [];
              }
              searchResult[alphabet].push(brand);
            }
          });
        });
        this.filterBrands = searchResult;
      } else {
        this.filterBrands = '';
      }
    },
    searchCountry() {
      if (this.searchCountryValue) {
        this.$SO.each(this.options.country, (letter, listCountry) => {
          this.$SO.each(listCountry, (key, country) => {
            if (country.name.toLowerCase().includes(this.searchCountryValue.toLowerCase())) {
              this.options.country[letter][key].isHidden = false;
            } else {
              this.options.country[letter][key].isHidden = true;
            }
          });
        });
      } else {
        this.searchCountryValue = '';
      }
    },
    searchRegion() {
      if (this.searchRegionValue) {
        this.$SO.each(this.options.region, (key, region) => {
          if (region.name.toLowerCase().includes(this.searchRegionValue.toLowerCase())) {
            this.options.region[key].isHidden = false;
          } else {
            this.options.region[key].isHidden = true;
          }
        });
      } else {
        this.searchRegionValue = '';
      }
    },
    selectCombinationName({ option, key }) {
      this.listCombinationGroup[key].combinationName = option.name;
      this.listCombinationGroup[key].combinationId = option._id;
      this.listCombinationGroup[key].combinationMySocoSqlId = option.my_soco_sql_id;
      this.listCombinationGroup[key].options = '';
    },
    setSection(value) {
      this.section = value;
    },
    showCountryDropdown() {
      this.isOpenCountryDropdown = true;
      this.isReadOnlyInputCountry = true;
    },
    showMegaMenuBrands() {
      this.isOpenMegaMenuBrands = true;
      this.isReadOnlyInputProductName = true;
    },
    showMegaMenuCategories() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'selectCategory',
      });
      this.isReadOnlyInputCategory = true;
    },
    showRegionDropdown() {
      this.isOpenRegionDropdown = true;
      this.isReadOnlyInputRegion = true;
    },
    submitBrand() {
      this.isLoadingSubmitBrand = true;
      this.$store
        .dispatch('addProduct/addBrand', {
          name: this.form.brand.name,
          description: this.form.brand.description,
          region: this.form.region.name,
          country: this.form.country.name,
          logo: this.imageBrand,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('addProduct/setNewBrand', response.data.data);
            this.section = 'add_product_detail';
          } else {
            this.$toasted.global.error('Silahkan coba beberapa saat lagi');
          }
          this.isLoadingSubmitBrand = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingSubmitBrand = false;
          this.$toasted.global.error('Silahkan coba beberapa saat lagi');
        });
    },
    updateBrand() {
      this.isLoadingSubmitBrand = true;
      this.$store
        .dispatch('addProduct/updateBrand', {
          name: this.form.brand.name,
          description: this.form.brand.description,
          region: this.form.region.name,
          country: this.form.country.name,
          logo: this.imageBrand,
        })
        .then((response) => {
          if (response.status === 200) {
            this.section = 'summary';
          } else {
            this.$toasted.global.error('Silahkan coba beberapa saat lagi');
          }
          this.isLoadingSubmitBrand = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingSubmitBrand = false;
          this.section = 'summary';
          this.$toasted.global.error('Silahkan coba beberapa saat lagi');
        });
    },
    submitAddProduct() {
      this.$validator.validateAll().then((validated) => {
        if (validated) {
          const payload = {
            brand: {
              name: this.form.brand.name,
            },
            name: this.form.product.name,
            categories: [],
            images: [
              {
                is_cover: true,
                url: this.imageProduct,
              },
            ],
            user_contribution: {
              is_user_contribution: this.$store.state.auth.userProfile.is_admin ? false : true,
              user_id: this.$store.state.auth.user_id,
              user_name: this.$store.state.auth.user_name,
            },
            description: this.form.product.description,
            combinations: [],
          };

          if (this.form.brand._id) {
            payload.brand.id = this.form.brand._id;
            payload.brand.my_soco_sql_id = this.form.brand.my_soco_sql_id;
          }

          if (this.newBrand._id) {
            payload.brand.id = this.newBrand._id;
            payload.brand.my_soco_sql_id = this.newBrand.my_soco_sql_id;
          }

          // assign categories
          this.$SO.each(this.$store.state.addProduct.categories, (key, category) => {
            payload.categories.push({
              id: category._id,
              name: category.name,
              my_soco_sql_id: category.my_soco_sql_id,
              rating_types: category.rating_types,
            });
          });
          if (this.attributeName === 'multiple_combination') {
            this.$SO.each(this.multiple_combination, (key, listAttributes) => {
              const combination_temp = {
                attributes: {},
                images: [],
              };
              let combinationCategoryLowerCase;
              this.$SO.each(listAttributes.attributes, (combinationName, combination) => {
                if (listAttributes.attributes[combinationName].data) {
                  combinationCategoryLowerCase = combinationName.toLowerCase();
                  combination_temp.attributes[combinationCategoryLowerCase] = {
                    name: listAttributes.attributes[combinationName].data.name,
                  };
                  combination_temp.attributes[combinationCategoryLowerCase]._id =
                    listAttributes.attributes[combinationName].data['_id'];
                  combination_temp.attributes[combinationCategoryLowerCase].my_soco_sql_id =
                    listAttributes.attributes[combinationName].data.my_soco_sql_id;
                }

                if (!combination_temp.images.length && combinationName === 'images') {
                  combination_temp.images.push(listAttributes.attributes[combinationName]);
                }
              });
              if (Object.keys(combination_temp.attributes).length) {
                payload.combinations.push(combination_temp);
              }
            });
          } else {
            this.$SO.each(this.attributes, (combinationName, listCombination) => {
              const combination_temp = { attributes: {}, images: [] };
              let combinationCategoryLowerCase;
              this.$SO.each(listCombination, (key, combination) => {
                if (this.attributes[combinationName][key].data) {
                  combinationCategoryLowerCase = combinationName.toLowerCase();
                  combination_temp.attributes[combinationCategoryLowerCase] = { name: combination.data.name };
                  combination_temp.attributes[combinationCategoryLowerCase]._id = combination.data['_id'];
                  combination_temp.attributes[combinationCategoryLowerCase].my_soco_sql_id =
                    combination.data.my_soco_sql_id;
                  combination_temp.images.push(combination.images);
                }
              });

              if (Object.keys(combination_temp.attributes).length) {
                payload.combinations.push(combination_temp);
              }
            });
          }
          this.$MS_SOCO_PUBLIC_API_URL
            .post(`/products`, payload)
            .then((res) => {
              if (res.status == 200) {
                this.section = 'success';
              }
            })
            .catch((err) => {
              this.$toasted.global.error(
                'Maaf, Produk dan Brand yang kamu masukkan sudah ada atau sedang dalam kurasi oleh tim kami. Terimakasih.'
              );
              console.error('err', err);
            });
        } else {
          if (document.getElementById(this.$validator.errors.items[0].field.split(' ').join(''))) {
            document.getElementById(this.$validator.errors.items[0].field.split(' ').join('')).scrollIntoView();
          }
        }
      });
    },
    update(section) {
      if (section === 'edit_brand') {
        this.updateBrand();
        return;
      }

      this.section = 'summary';
    },
    verifyProduct() {
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products`, {
          params: {
            filter: {
              name: { $regex: this.form.product.name, $options: 'i' },
              'brand.my_soco_sql_id': this.form.brand.my_soco_sql_id,
            },
            fields: 'id name brand images',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (this.$SO.size(response.data.data) === 1) {
              if (response.data.data[0].name.toLowerCase() === this.form.product.name.toLowerCase()) {
                this.$store.commit('toggleModalGlobalState', {
                  modalName: 'productExisted',
                });
                this.$store.commit('setDataModal', {
                  modalName: 'productExisted',
                  value: response.data.data[0],
                });
                return;
              }
            }

            this.section = 'add_product_detail';
          } else {
            this.$toasted.global.error('Silahkan coba beberapa saat lagi');
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toasted.global.error('Silahkan coba beberapa saat lagi');
        });
    },
  },
};
</script>
